import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import PasswordInput from '../components/PasswordInput';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      toast.error('Invalid reset token');
      navigate('/forgot-password');
    }
  }, [token, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }

    if (password.length < 6) {
      toast.error('Password must be at least 6 characters');
      return;
    }

    setLoading(true);

    try {
      await axios.post(`${API_URL}/auth/reset-password`, {
        token,
        password
      });
      toast.success('Password reset successful!');
      navigate('/signin');
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to reset password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-8">
      <div className="w-full max-w-md">
        <Link to="/signin" className="text-blue-600 hover:text-blue-700 mb-6 inline-block">
          &lt; Back to Sign In
        </Link>
        <h1 className="text-4xl font-bold text-blue-600 mb-8">Reset Password</h1>
        
        <form onSubmit={handleSubmit} className="space-y-6">
          <PasswordInput
            label="New Password"
            labelClassName="block text-gray-700 font-medium mb-2"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter new password"
            autoComplete="new-password"
            inputClassName="w-full rounded-lg border border-gray-300 px-4 py-3 pr-11 focus:border-transparent focus:ring-2 focus:ring-blue-600"
            toggleClassName="text-gray-500 hover:text-gray-800"
            required
          />

          <PasswordInput
            label="Confirm New Password"
            labelClassName="block text-gray-700 font-medium mb-2"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Confirm new password"
            autoComplete="new-password"
            inputClassName="w-full rounded-lg border border-gray-300 px-4 py-3 pr-11 focus:border-transparent focus:ring-2 focus:ring-blue-600"
            toggleClassName="text-gray-500 hover:text-gray-800"
            required
          />

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? 'Resetting...' : 'Reset Password'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
